import APICall from './../utils/APICall';

export default class TreasuryBillClass {

    static CreateTreasuryBillListtings = async (data) => {
        return await APICall(`/api/TreasuryBills/admin/create-treasury-bill-listing`, "POST", data)
    }

    static ListOfBookings = async (pageIndex, pageSize, search, startDate, endDate, status) => {
        return await APICall(`/api/TreasuryBills/admin/treasury-bill-bookings?page=${pageIndex}&pageLimit=${pageSize}&search=${search}&startDate=${startDate}&endDate=${endDate}&status=${status}`, "GET")
    }

    static ListOfTreasuryBills = async (pageIndex, pageSize, search, startDate, endDate, status, tenorClass) => {
        let queryString = `/api/TreasuryBills/admin/list-treasury-bills?`;
        if(pageIndex) queryString += `page=${pageIndex}`
         if(pageSize) queryString += `&pageLimit=${pageSize}`
        if (search) queryString += `&search=${search}`;
        if (status) queryString += `&approvalStatus=${status}`;
        if (startDate) queryString += `&startDate=${startDate}`;
        if (endDate) queryString += `&endDate=${endDate}`;
        if (tenorClass) queryString += `&tenor=${tenorClass}`;
        return await APICall(queryString, "GET")
    }

    static getTreasuryBillById = async (id) => {
        return await APICall(`/api/TreasuryBills/admin/treasury-bill-listing/${id}`, "GET")
    }

    static getBookingById = async (id) => {
        return await APICall(`/api/TreasuryBills/admin/treasury-bill-bookings/${id}`, "GET")
    }

    static approveRejectTreasuryBill = async (id, action) => {
        return await APICall(`/api/TreasuryBills/admin/treasury-bill-listing/approve-or-reject`, "POST", {
            treasuryBillListingID: id,
            status: action
        })
    }
   
    
    static updateTreasuryBillListtings = async (data) => {
        return await APICall(`/api/TreasuryBills/admin/update-treasury-bill-listings`, "POST", data)
    }

    static resendBookingAdvise = async (bookingId) => {
        return await APICall(`/api/TreasuryBills/admin/resend-booking-advise?treasuryBillBookingId=${bookingId}`, "GET")
    }
    
    static deactivateBooking = async (bookingId) => {
        return await APICall(`/api/TreasuryBills/admin/treasury-bill-listing/deactivate/${bookingId}`, "PATCH")
    }
    static exportTreasuryBookings = async (search, startDate, endDate, status) => {
        let queryString = `/api/TreasuryBills/admin/export-treasury-bill-bookings?`;
        
        if (search) queryString += `search=${search}`;
        if (status) queryString += `&status=${status}`;
        if (startDate) queryString += `&startDate=${startDate}`;
        if (endDate) queryString += `&endDate=${endDate}`;
        return await APICall(queryString, "GET")
    }

    static exportTreasuryBills = async (search, startDate, endDate, status) => {
        let queryString = `/api/TreasuryBills/admin/export-treasury-bill-listings?`;
        
        if (search) queryString += `search=${search}`;
        if (status) queryString += `&status=${status}`;
        if (startDate) queryString += `&startDate=${startDate}`;
        if (endDate) queryString += `&endDate=${endDate}`;
        return await APICall(queryString, "GET")
    }
}
